import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { APIResponse, AppData, NotificationData, NumberingTypes, ObjectUtils, UserSettings } from 'fakturnia-shared';
import { Subscription } from 'rxjs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SettingsService } from 'shared/services/settings.service';
import { SettingsApiService } from 'shared/services/api/settings.api.service';
import { ToastService } from 'shared/services/toast.service';
import { DateTime } from 'luxon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SnackbarService } from 'shared/services/snackbar.service';

@Component({
  selector: 'app-number-format',
  standalone: true,
  imports: [CommonModule, MatSelectModule, MatFormFieldModule, MatTooltipModule, ReactiveFormsModule],
  templateUrl: './number-format.component.html',
  styleUrl: './number-format.component.scss'
})
export class NumberFormatComponent implements OnInit, OnDestroy {

  private _subscriptions: Subscription[] = [];

  private _today = DateTime.now()
  formats = AppData.DocumentNumberFormats
  control = new FormControl()
  numberingType = null
  
  constructor(
    private _settingsService: SettingsService,
    private _settingsApiService: SettingsApiService,
    private _toastService: ToastService,
    private _snackbarService: SnackbarService
  ) { }

  public formatSample(format) {
    format = format.replace('NUMER', '1').replace('MM', this._today.month < 10 ? `0${this._today.month}` : this._today.month).replace('YYYY', this._today.year)
    return format
  }

  public isConfigInvalid() {
    const format = this.formats.find(x=>x.format == this.control.value)
    return this.isDisabled(format)
  }

  public isDisabled(format) {
    if(this.numberingType == null) return true
    if(this.numberingType == NumberingTypes.MONTH && !format.format.includes('MM')) return true
    return false
  }

  ngOnInit(): void {
    this._subscriptions.push(
      this._settingsService.currentUserSettings.subscribe({
        next: (userSettings: UserSettings) => {
          this.numberingType = ObjectUtils.getNestedValue(userSettings, "settings.autocomplete.numberingType")
          this.control.setValue(ObjectUtils.getNestedValue(userSettings, "settings.autocomplete.numberingFormat"), { emitEvent: false })
        }
      }))

      this._subscriptions.push(
        this.control.valueChanges.subscribe((value) => {
          this._settingsApiService.updateNumberingFormat(value)
            .subscribe({
              next: (response: APIResponse) => {
                if (!response.success) {
                  this._settingsService.refreshSettings()
                  this._snackbarService.showSnackBar(
                    response.message,
                    "error", 
                    4000
                  )
                  return
                }

                this._settingsService.refreshSettings()
                this._snackbarService.showSnackBar(
                  "Zapisano zmiany",
                  "success", 
                  4000
                )
                
              }
            })
        })
      )
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach(sub => sub.unsubscribe());
  }
}
